import { configureStore } from '@reduxjs/toolkit'
import authReducer from "@/redux/auth/authSlice"
import modalReducer from "./popup/modalSlice";
import currentUser from "./profile/userProfileSlice";
import travelCountReducer from "./checkout/travelCount";
import checkoutReducer from "./checkout/checkoutpage";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    modal: modalReducer,
    currentUser: currentUser,
    travel: travelCountReducer,
    checkoutPage: checkoutReducer,
  },
   middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
})